import { Formik, FormikHelpers } from 'formik'

import { useSwitch2FAMethod, useVerify2FAtoTotpSwitch } from 'src/hooks'
import { IVerificationCodeForm } from 'src/types'
import { codeVerificationSchema } from 'src/common/validations'
import { SwitchForm } from './switch-form.component'

export const SwitchFormWrapper = () => {
  const { mutateAsync: switch2FAMethod, data: switchData } = useSwitch2FAMethod()
  const { mutateAsync: verifyToTotpSwitch } = useVerify2FAtoTotpSwitch()

  const handleSubmit = async (
    values: IVerificationCodeForm,
    { resetForm }: FormikHelpers<IVerificationCodeForm>,
  ) => {
    if (switchData?.totpUri) {
      await verifyToTotpSwitch(values.code)
    } else {
      await switch2FAMethod(values.code)
    }
    resetForm()
  }

  return (
    <Formik
      validationSchema={codeVerificationSchema}
      initialValues={{ code: '' }}
      onSubmit={handleSubmit}
    >
      <SwitchForm totpUri={switchData?.totpUri} />
    </Formik>
  )
}
